(() => {
  if (window.EventCalendar) return;

  class EventCalendar {
    constructor(section) {
      this.section = section;

      this.grid = section.querySelector("[data-calendar-grid]");
      this.monthYear = section.querySelector("[data-month-year]");

      // modal elements (global)
      this.title = document.querySelector("[data-event-title]");
      this.desc = document.querySelector("[data-event-description]");
      this.link = document.querySelector("[data-event-link]");

      // Bootstrap modal instance
      this.modalEl = document.getElementById('eventCalendarModal');
      this.bsModal = new bootstrap.Modal(this.modalEl);

      // collect events from blocks
      this.events = [];

      try {
        const wrapper = section.parentElement;

        wrapper.querySelectorAll(".event-data").forEach(el => {
          try {
            const data = JSON.parse(el.textContent.trim());
            this.events.push(data);
          } catch (err) {
            console.warn("Invalid event JSON:", err);
          }
        });

      } catch (e) {
        console.warn("Event parsing failed:", e);
      }

      const today = new Date();
      this.currentMonth = today.getMonth();
      this.currentYear = today.getFullYear();

      this.bindButtons();
      this.render();
    }

    bindButtons() {
      this.section.querySelector("[data-prev]")?.addEventListener("click", () => this.changeMonth(-1));
      this.section.querySelector("[data-next]")?.addEventListener("click", () => this.changeMonth(1));
    }

    render() {
      if (!this.grid || !this.monthYear) return;

      const firstDay = new Date(this.currentYear, this.currentMonth, 1).getDay();
      const daysInMonth = new Date(this.currentYear, this.currentMonth + 1, 0).getDate();

      const monthNames = [
        "January","February","March","April","May","June",
        "July","August","September","October","November","December"
      ];

      this.monthYear.textContent = `${monthNames[this.currentMonth]} ${this.currentYear}`;
      this.grid.innerHTML = "";

      const daysOfWeek = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
      daysOfWeek.forEach(day => {
        const el = document.createElement("div");
        el.textContent = day;
        el.style.fontWeight = "bold";
        this.grid.appendChild(el);
      });

      for (let i = 0; i < firstDay; i++) {
        this.grid.appendChild(document.createElement("div"));
      }

      for (let day = 1; day <= daysInMonth; day++) {
        const dayEl = document.createElement("div");
        dayEl.classList.add("calendar-day");
        dayEl.textContent = day;

        const eventDate = `${this.currentYear}-${String(this.currentMonth + 1).padStart(2,"0")}-${String(day).padStart(2,"0")}`;

        const events = this.events.filter(e => String(e.date) === eventDate);

        if (events.length) {
          dayEl.classList.add("event");
          dayEl.style.cursor = "pointer";

          dayEl.addEventListener("click", () => this.showModal(events[0]));
        }

        this.grid.appendChild(dayEl);
      }
    }

    showModal(event) {
      this.title.textContent = event.title || "No Title";
      this.desc.textContent = event.description || "No Description";
      this.link.href = event.link || "#";

      this.bsModal.show();
    }

    changeMonth(delta) {
      this.currentMonth += delta;

      if (this.currentMonth < 0) {
        this.currentMonth = 11;
        this.currentYear--;
      } else if (this.currentMonth > 11) {
        this.currentMonth = 0;
        this.currentYear++;
      }

      this.render();
    }
  }

  window.EventCalendar = EventCalendar;

  document.querySelectorAll("[data-event-calendar]").forEach(section => {
    if (!section.__calendarInitialized) {
      section.__calendarInitialized = true;
      new EventCalendar(section);
    }
  });

})();